import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PickupWarehouse, PickupWarehouseDataService } from '@vi-succ/pickup-warehouse-domain';
import { PickupLocation, PickupLocationDataService } from '@vi-succ/shoppingcart-domain';
import { Observable, map } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EtPickupLocationDataService implements PickupLocationDataService, PickupWarehouseDataService {
  private headers: HttpHeaders = new HttpHeaders().set('X-API-KEY', environment.backend.apiKey);

  constructor(private http: HttpClient) {}

  getPickupLocations(customer: string | undefined, salesOrg: string, language: string): Observable<PickupLocation[]> {
    return this.http.get<PickupLocation[]>(environment.backend.url + `/delivery-options/pickup-locations`, {
      headers: this.headers,
      params: {
        customer: customer ? customer : '',
        language: language,
        salesorg: salesOrg,
      },
    });
  }

  getPickupWarehouses(customer: string | undefined, salesOrg: string, language: string): Observable<PickupWarehouse[]> {
    return this.http.get<PickupLocation[]>(environment.backend.url + `/delivery-options/pickup-locations`, {
      headers: this.headers,
      params: {
        customer: customer ? customer : '',
        language: language,
        salesorg: salesOrg,
      },
    });
  }

  getPickupAvailability(salesOrg: string): Observable<boolean> {
    return this.http
      .get<{
        available: boolean;
      }>(environment.backend.url + `/delivery-options/pickup-availability`, {
        headers: this.headers,
        params: { salesOrg },
      })
      .pipe(map(({ available }) => available));
  }
}
